import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";

const ExitIntentModal = () => {
  const [isVisible, setIsVisible] = useState(false);
  const modalRef = useRef(null);

  useEffect(() => {
    // Show modal on refresh
    // setIsVisible(true);

    // Show modal after 3 mins interval
    const interval = setInterval(() => {
      setIsVisible(true);
    }, 3 * 60 * 1000);

    // Show modal when user scrolls
    const handleScroll = () => {
      setIsVisible(true);
      window.removeEventListener("scroll", handleScroll);
    };
    window.addEventListener("scroll", handleScroll);

    return () => {
      clearInterval(interval);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Close modal if user clicks outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setIsVisible(false);
      }
    };
    if (isVisible) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isVisible]);

  const openWhatsapp = () => {
    setIsVisible(false);
    window.open("https://wa.me/2349025525239", "_blank");
  }

  return (
    isVisible && (
      <div className="fixed inset-0 bg-black bg-opacity-50 p-4 flex justify-center items-center z-50">
        <div
          ref={modalRef}
          className="bg-[#001F4D] text-white p-6 rounded-lg shadow-lg max-w-md w-full relative"
        >
          <button
            className="absolute top-2 right-2 text-white text-xl"
            onClick={() => setIsVisible(false)}
          >
            &times;
          </button>
          <p className="text-center mb-4">Before you Leave!</p>
          <h2 className="text-xl font-bold text-center">
            Do You Want to Speak with a Senior Corporate Law or Litigation Expert?
          </h2>
          <div className="flex flex-col items-center mt-4">
            <button 
            className="bg-[#E20BE3] text-white px-6 py-2 rounded-lg w-full mb-2"
            onClick={() => setIsVisible(false)}
            >
              <Link to="/book">SCHEDULE AN APPOINTMENT</Link>
            </button>
            <span className="text-sm text-gray-300">OR</span>
            <button
              className="bg-green-500 text-white px-6 py-2 rounded-lg w-full mt-2"
              onClick={openWhatsapp}
            >
              💬 CHAT VIA WHATSAPP!
            </button>
          </div>
        </div>
      </div>
    )
  );
};

export default ExitIntentModal;
